import Routing from './utils/Routing';


const App = () => {
  return (
    <>
    <Routing/>
    </>
  )
}

export default App